import React from 'react';

import { TailSpin } from './TailSpin';
import { Grid } from './Grid';
import { ThreeDots } from './ThreeDots';

import { LoaderProps } from './loaderTypes';

export const Loader = ({
  className,
  height = 24,
  width = 24,
  color = '#588CB0',
  type = 'TailSpin',
}: LoaderProps) => {
  switch (type) {
    case 'Grid': {
      return <Grid className={className} height={height} width={width} color={color} />;
    }
    case 'ThreeDots': {
      return <ThreeDots className={className} height={height} width={width} color={color} />;
    }
    case 'TailSpin':
    default: {
      return <TailSpin className={className} height={height} width={width} color={color} />;
    }
  }
};
